import { Popover } from "@portal/BaseComponents/PopOver/AntPopOver";
import { PopoverProps } from "@portal/BaseComponents/PopOver/type";
import { ColumnTitle } from "@sinecycle/growcomponents";
import { FilterBlock, FilterBlockProps } from "../FilterBlock/FilterBlock";

interface FilterDropdownDownProps {
  filterBlockProps: FilterBlockProps;
  filterComponent: PopoverProps["content"];
  filterTitle: string;
  onopenChange?: PopoverProps["onOpenChange"];
}

function FilterDropdownDown(props: FilterDropdownDownProps) {
  const { filterBlockProps, filterComponent, filterTitle, onopenChange } =
    props;

  const Title = (
    <ColumnTitle hasSymbol={filterBlockProps.hasSymbol} strong>
      {filterTitle}
    </ColumnTitle>
  );

  return (
    <Popover
      title={Title}
      open={filterBlockProps.open}
      content={filterComponent}
      onOpenChange={onopenChange}
      arrow={false}
      placement="bottomLeft"
      trigger={["click"]}
      destroyTooltipOnHide
    >
      <FilterBlock {...filterBlockProps} />
    </Popover>
  );
}

export { FilterDropdownDown };
